// BreadCrumb.js
import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link } from "react-router-dom";
const BreadCrumb = (props) => {
    return (React.createElement(Breadcrumb, { className: `generic-breadcrumb ${props.parentClassName ? props.parentClassName : ""}` }, props.list &&
        props.list.length > 0 &&
        props.list.map((crumb, idx) => {
            return crumb.link ? (React.createElement(Breadcrumb.Item, { as: Link, href: crumb.link, to: crumb.link, key: idx, onClick: crumb.disabled ? undefined : crumb.onClick, className: "DMSansMedium_12_500" },
                crumb.icon && React.createElement("i", { className: `${crumb.icon}` }),
                !crumb.icon && crumb.title,
                " ")) : (React.createElement(Breadcrumb.Item, { key: idx, className: "DMSansMedium_12_500", active: true },
                crumb.icon && React.createElement("i", { className: `${crumb.icon} ` }),
                !crumb.icon && crumb.title,
                " "));
        })));
};
export default BreadCrumb;
